import React, { useState, useEffect } from 'react';
import Banner from '../components/Banner';
// import Header from '../components/Header';

// Images 
import BG2 from '../assets/img/bg-2.png';
import award1 from '../assets/img/award-1.png';
import award2 from '../assets/img/award-2.png';
import aboutImg from '../assets/img/about-sec.png';
import checkIcon from '../assets/img/check-icon.svg';
import icon6 from '../assets/img/icon-6.svg';
import icon7 from '../assets/img/icon-7.svg';

import ImageWithText from '../components/ImageWithText';
import webPortalServices from '../../services/webPortal.services';
import Steps from '../components/Steps';
import OurBenefits from '../components/OurBenefits';
import OurServices from '../components/OurServices';
import QuickPoint from '../components/QuickPoint';
import OurTeam from '../components/OurTeam';
import Faq from '../components/Faq';
import Testimonials from '../components/Testimonials';
import DownloadApp from '../components/DownloadApp';
import Counter from '../components/Counter';

const Home = () => {
  const [pageContets, setPageContets] = useState([]);

  useEffect(()=>{
   webPortalServices.customizedData().then((res)=>{
    setPageContets(res.data.webNavMenuList)
  });
 
},[])

const filterHomePageContent = pageContets.filter(item => item.status === 1 && item.pageUrl ==='home');
  return (
    <>
      {/* <Header /> */}
      <Banner />
      <section className="tagline-sec">
        <img src={BG2} alt="" className="w-100" />
        <div className="tagline-text">
          <div className="container c_container">
            <div className="row">
              <div className="col-12">
                <h4 className="heading-1fff text-white text-center" data-aos="fade-up">
                  { filterHomePageContent[0]?.heading ?filterHomePageContent[0]?.heading:'By using the latest digital technology, Mobile Medical Diagnostics provides a community based and flexible radiology services solution, resulting in improved access to diagnostic services for healthcare facilities nationwide.'}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="award-sec">
        <div className="container c_container">
          <div className="row">
            <div className="col-12 text-center">
              <img src={award1} alt="" />
              <img src={award2} alt="" />
            </div>
          </div>
        </div>
      </section>

      <ImageWithText 
        image={aboutImg}
        smallHeading={`${filterHomePageContent[0]?.sectionOneSmallHeadin ?filterHomePageContent[0]?.sectionOneSmallHeadin:'About Us'}`} 
        heading={`${filterHomePageContent[0]?.sectionOneHeading ? filterHomePageContent[0].sectionOneHeading:"About Testigo On Demand Mobile X-Ray Solutions"}`}
        para={`${filterHomePageContent[0]?.sectionOneParagraph ? filterHomePageContent[0].sectionOneParagraph:"We are the only fully licensed mobile radiology service in Ireland. Our mantra is moving equipment not patients and our mission is to bring quality care and diagnostics to communities in a clinically compliant manner. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries."}`}
        buttonLabel="Read More"
        buttonLink="#"
      />
      <Steps />
      <OurBenefits />
      <OurServices />
      <QuickPoint
            point1Icon={checkIcon}
            point1Text="We accept all requisitions"    
            point2Icon={icon6}
            point2Text="Book an Appointment"    
            point3Icon={icon7}
            point3Text="Exam Prep Instructions"    
         />
      <OurTeam />
      <Faq />
      <Testimonials />
      <DownloadApp />
      <Counter />
    </>
  );
};

export default Home;